import { Grid, Paper, TextField } from '@material-ui/core';
import React from 'reactn';
import { NumberField } from '../../components/NumberField';
import { SectionTitle } from '../../components/SectionTitle';
import { globalStyles } from '../../style/GlobalStyles';
import { SimulazioniSrlInputProps } from './DatiSimulazioniSrl';

export default function CompDivSimulazioniSrl(props: SimulazioniSrlInputProps) {
    const gClasses = globalStyles();

    const { state } = props;

    return (
        <React.Fragment>
            <Paper className={gClasses.mainPaper}>
            <SectionTitle primary={true} text="4° Simulazione - società non trasparente - compenso agli amministratori e distribuzione dividendi"></SectionTitle>
                <SectionTitle text="Società"></SectionTitle>
                <TextField
                    name="G48"
                    label="Ragione sociale"
                    value={state.datiSimulazioniSrl.G48}
                    className={gClasses.longTextFieldReadOnly}
                    InputLabelProps={{
                        shrink: true,
                        disabled: true
                    }}
                    inputProps={{tabIndex: -1}}
                    margin="normal"
                />

                <Grid container spacing={3}>
                    <Grid item>
                        <NumberField
                            name="K62"
                            label="Utile di bilancio al lordo dell'IRES"
                            value={state.datiSimulazioniSrl.K62}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="D89"
                            label="Compensi agli amministratori"
                            value={state.datiSimulazioniSrl.D89}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                            special={true}
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="I8"
                            label="Contributi su compensi agli amministratori (2/3)"
                            value={state.compDivSimulazioniSrl.I8}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                            special={true}
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="K63"
                            label="Variazioni fiscali in aumento"
                            value={state.datiSimulazioniSrl.K63}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="K64"
                            label="Variazioni fiscali in diminuzione"
                            value={state.datiSimulazioniSrl.K64}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="I11"
                            label="Reddito d'impresa - fiscale"
                            value={state.compDivSimulazioniSrl.I11}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="I11"
                            label="Imponibile IRES"
                            value={state.compDivSimulazioniSrl.I11}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="I13"
                            label="IRES"
                            value={state.compDivSimulazioniSrl.I13}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                            special={true}
                        />
                    </Grid>
                    <Grid item>
                        <NumberField
                            name="I14"
                            label="Utile di bilancio"
                            value={state.compDivSimulazioniSrl.I14}
                            className={gClasses.textFieldReadOnly}
                            readOnly={true}
                        />
                    </Grid>
                </Grid>
                <Grid item>
                    <NumberField
                        name="D88"
                        label="Distribuzione di dividendi per complessivi euro"
                        value={state.datiSimulazioniSrl.D88}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                        special={true}
                    />
                </Grid>
            </Paper>

            <Paper className={gClasses.mainPaper}>
                <SectionTitle primary={true} text="1° Socio"></SectionTitle>
                <TextField
                    name="C52"
                    label="Nome"
                    value={state.datiSimulazioniSrl.C52}
                    className={gClasses.textFieldReadOnly}
                    InputLabelProps={{
                        shrink: true,
                        disabled: true
                    }}
                    inputProps={{tabIndex: -1}}
                    margin="normal"
                />
                <SectionTitle text="Redditi"></SectionTitle>
                <NumberField
                    name="E118"
                    label="Pensione"
                    value={state.datiSimulazioniSrl.E118}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E119"
                    label="Lav. dipendente e assim."
                    value={state.datiSimulazioniSrl.E119}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="G91"
                    label="Compenso Ammin."
                    value={state.datiSimulazioniSrl.G91}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="D26"
                    label="al netto di 1/3 contr."
                    value={state.compDivSimulazioniSrl.D26}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E26"
                    label="Compenso netto"
                    value={state.compDivSimulazioniSrl.E26}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E120"
                    label="Assimilati lav. dipendente"
                    value={state.datiSimulazioniSrl.E120}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E121"
                    label="Impr. minore/ Lav. auton."
                    value={state.datiSimulazioniSrl.E121}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E122"
                    label="Diversi lettere i) e l)"
                    value={state.datiSimulazioniSrl.E122}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E123"
                    label="Fabbricati locati"
                    value={state.datiSimulazioniSrl.E123}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E31"
                    label={"Dividendi (" + state.datiSimulazioniSrl.E111 + "%)"}
                    value={state.compDivSimulazioniSrl.E31}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
                <NumberField
                    name="E124"
                    label="Altri"
                    value={state.datiSimulazioniSrl.E124}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E125"
                    label="Abitazione principale"
                    value={state.datiSimulazioniSrl.E125}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E127"
                    label="Redditi a cedolare secca"
                    value={state.datiSimulazioniSrl.E127}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E38"
                    label="Reddito complessivo"
                    value={state.compDivSimulazioniSrl.E38}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E39"
                    label="Redd. compl. per detraz."
                    value={state.compDivSimulazioniSrl.E39}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <Grid container>
                    <NumberField
                        name="G22"
                        label="Redditi IVS"
                        value={state.compDivSimulazioniSrl.G23}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="H23"
                        label="Contr. IVS"
                        value={state.compDivSimulazioniSrl.H23}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>
                <Grid container>
                    <NumberField
                        name="I25"
                        label="Oneri deducibili"
                        value={state.compDivSimulazioniSrl.I25}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I26"
                        label="Reddito imponibile"
                        value={state.compDivSimulazioniSrl.I26}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I27"
                        label="Irpef lorda"
                        value={state.compDivSimulazioniSrl.I27}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>
                <NumberField
                    name="I29"
                    label="Familiari a carico"
                    value={state.compDivSimulazioniSrl.I29}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I30"
                    label="Lavoro dipend."
                    value={state.compDivSimulazioniSrl.I30}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I31"
                    label="Pensione"
                    value={state.compDivSimulazioniSrl.I31}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I33"
                    label="Impresa/lav. Auton. e lav. non dipend."
                    value={state.compDivSimulazioniSrl.I33}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="L122"
                    label="Altre"
                    value={state.datiSimulazioniSrl.L122}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I35"
                    label="Tot. Detrazioni"
                    value={state.compDivSimulazioniSrl.I35}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I37"
                    label="Irpef netta"
                    value={state.compDivSimulazioniSrl.I37}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
                {/* <NumberField
                        name="G91"
                        label="Compenso Ammin."
                        value={state.datiSimulazioniSrl.G91}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    /> */}
                {/* <NumberField
                        name="M25"
                        label="Quota dividendo"
                        value={state.compDivSimulazioniSrl.M25}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    /> */}
                <Grid container>
                    <NumberField
                        name="K33"
                        label="Dividendi Imp.Sost."
                        value={state.compDivSimulazioniSrl.K33}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="M33"
                        label="Imp.Sost."
                        value={state.compDivSimulazioniSrl.M33}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>
                <SectionTitle text="Addizionali Irpef"></SectionTitle>
                <NumberField
                    name="K37"
                    label="Regionale"
                    value={state.compDivSimulazioniSrl.K37}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
                <NumberField
                    name="M37"
                    label="Comunale"
                    value={state.compDivSimulazioniSrl.M37}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
            </Paper>
            <Paper className={gClasses.mainPaper}>
                <SectionTitle primary={true} text="2° Socio"></SectionTitle>
                <TextField
                    name="C53"
                    label="Nome"
                    value={state.datiSimulazioniSrl.C53}
                    className={gClasses.textFieldReadOnly}
                    InputLabelProps={{
                        shrink: true,
                        disabled: true
                    }}
                    inputProps={{tabIndex: -1}}
                    margin="normal"
                />
                <SectionTitle text="Redditi"></SectionTitle>
                <NumberField
                    name="E133"
                    label="Pensione"
                    value={state.datiSimulazioniSrl.E133}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E134"
                    label="Lav. dipendente e assim."
                    value={state.datiSimulazioniSrl.E134}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="G92"
                    label="Compenso Ammin."
                    value={state.datiSimulazioniSrl.G92}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="D57"
                    label="al netto di 1/3 contr."
                    value={state.compDivSimulazioniSrl.D57}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E57"
                    label="Compenso netto"
                    value={state.compDivSimulazioniSrl.E57}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E135"
                    label="Assimilati lav. dipendente"
                    value={state.datiSimulazioniSrl.E135}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E136"
                    label="Impr. minore/ Lav. auton."
                    value={state.datiSimulazioniSrl.E136}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E137"
                    label="Diversi lettere i) e l)"
                    value={state.datiSimulazioniSrl.E137}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E138"
                    label="Fabbricati locati"
                    value={state.datiSimulazioniSrl.E138}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E62"
                    label={"Dividendi (" + state.datiSimulazioniSrl.E111 + "%)"}
                    value={state.compDivSimulazioniSrl.E62}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
                <NumberField
                    name="E139"
                    label="Altri"
                    value={state.datiSimulazioniSrl.E139}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E140"
                    label="Abitazione principale"
                    value={state.datiSimulazioniSrl.E140}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E142"
                    label="Redditi a cedolare secca"
                    value={state.datiSimulazioniSrl.E142}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E69"
                    label="Reddito complessivo"
                    value={state.compDivSimulazioniSrl.E69}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E70"
                    label="Redd. compl. per detraz."
                    value={state.compDivSimulazioniSrl.E70}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <Grid container>
                    <NumberField
                        name="G54"
                        label="Redditi IVS"
                        value={state.compDivSimulazioniSrl.G54}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="H54"
                        label="Contr. IVS"
                        value={state.compDivSimulazioniSrl.H54}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>
                <Grid container>
                    <NumberField
                        name="I56"
                        label="Oneri deducibili"
                        value={state.compDivSimulazioniSrl.I56}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I57"
                        label="Reddito imponibile"
                        value={state.compDivSimulazioniSrl.I57}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I58"
                        label="Irpef lorda"
                        value={state.compDivSimulazioniSrl.I58}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>
                <NumberField
                    name="I60"
                    label="Familiari a carico"
                    value={state.compDivSimulazioniSrl.I60}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I61"
                    label="Lavoro dipend."
                    value={state.compDivSimulazioniSrl.I61}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I62"
                    label="Pensione"
                    value={state.compDivSimulazioniSrl.I62}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I64"
                    label="Impresa/lav. Auton. e lav. non dipend."
                    value={state.compDivSimulazioniSrl.I64}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="L137"
                    label="Altre"
                    value={state.datiSimulazioniSrl.L137}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I66"
                    label="Tot. Detrazioni"
                    value={state.compDivSimulazioniSrl.I66}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I68"
                    label="Irpef netta"
                    value={state.compDivSimulazioniSrl.I68}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
                {/* <NumberField
                        name="G92"
                        label="Compenso Ammin."
                        value={state.datiSimulazioniSrl.G92}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    /> */}
                {/* <NumberField
                        name="M56"
                        label="Quota dividendo"
                        value={state.compDivSimulazioniSrl.M56}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    /> */}
                <Grid container>
                    <NumberField
                        name="K64"
                        label="Dividendi Imp.Sost."
                        value={state.compDivSimulazioniSrl.K64}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="M64"
                        label="Imp.Sost."
                        value={state.compDivSimulazioniSrl.M64}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>
                <SectionTitle text="Addizionali Irpef"></SectionTitle>
                <NumberField
                    name="K68"
                    label="Regionale"
                    value={state.compDivSimulazioniSrl.K68}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
                <NumberField
                    name="M68"
                    label="Comunale"
                    value={state.compDivSimulazioniSrl.M68}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
            </Paper>
            <Paper className={gClasses.mainPaper}>
                <SectionTitle primary={true} text="3° Socio"></SectionTitle>
                <TextField
                    name="C54"
                    label="Nome"
                    value={state.datiSimulazioniSrl.C54}
                    className={gClasses.textFieldReadOnly}
                    InputLabelProps={{
                        shrink: true,
                        disabled: true
                    }}
                    inputProps={{tabIndex: -1}}
                    margin="normal"
                />
                <SectionTitle text="Redditi"></SectionTitle>
                <NumberField
                    name="E147"
                    label="Pensione"
                    value={state.datiSimulazioniSrl.E147}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E148"
                    label="Lav. dipendente e assim."
                    value={state.datiSimulazioniSrl.E148}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="G93"
                    label="Compenso Ammin."
                    value={state.datiSimulazioniSrl.G93}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="D88"
                    label="al netto di 1/3 contr."
                    value={state.compDivSimulazioniSrl.D88}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E88"
                    label="Compenso netto"
                    value={state.compDivSimulazioniSrl.E88}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E149"
                    label="Assimilati lav. dipendente"
                    value={state.datiSimulazioniSrl.E149}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E150"
                    label="Impr. minore/ Lav. auton."
                    value={state.datiSimulazioniSrl.E150}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E151"
                    label="Diversi lettere i) e l)"
                    value={state.datiSimulazioniSrl.E151}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E152"
                    label="Fabbricati locati"
                    value={state.datiSimulazioniSrl.E152}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E93"
                    label={"Dividendi (" + state.datiSimulazioniSrl.E111 + "%)"}
                    value={state.compDivSimulazioniSrl.E93}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
                <NumberField
                    name="E124"
                    label="Altri"
                    // value={state.datiSimulazioniSrl.E124}
                    value={Number(state.datiSimulazioniSrl.E153)}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E153"
                    label="Abitazione principale"
                    value={Number(state.datiSimulazioniSrl.E154)}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E156"
                    label="Redditi a cedolare secca"
                    value={state.datiSimulazioniSrl.E156}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E100"
                    label="Reddito complessivo"
                    value={state.compDivSimulazioniSrl.E100}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="E101"
                    label="Redd. compl. per detraz."
                    value={state.compDivSimulazioniSrl.E101}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <Grid container>
                    <NumberField
                        name="G85"
                        label="Redditi IVS"
                        value={state.compDivSimulazioniSrl.G85}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="H85"
                        label="Contr. IVS"
                        value={state.compDivSimulazioniSrl.H85}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>
                <Grid container>
                    <NumberField
                        name="I87"
                        label="Oneri deducibili"
                        value={state.compDivSimulazioniSrl.I87}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I88"
                        label="Reddito imponibile"
                        value={state.compDivSimulazioniSrl.I88}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="I89"
                        label="Irpef lorda"
                        value={state.compDivSimulazioniSrl.I89}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>
                <NumberField
                    name="I91"
                    label="Familiari a carico"
                    value={state.compDivSimulazioniSrl.I91}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I92"
                    label="Lavoro dipend."
                    value={state.compDivSimulazioniSrl.I92}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I93"
                    label="Pensione"
                    value={state.compDivSimulazioniSrl.I93}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I95"
                    label="Impresa/lav. Auton. e lav. non dipend."
                    value={state.compDivSimulazioniSrl.I95}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="L151"
                    label="Altre"
                    value={state.datiSimulazioniSrl.L151}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I97"
                    label="Tot. Detrazioni"
                    value={state.compDivSimulazioniSrl.I97}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                />
                <NumberField
                    name="I99"
                    label="Irpef netta"
                    value={state.compDivSimulazioniSrl.I99}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
                {/* <NumberField
                        name="G93"
                        label="Compenso Ammin."
                        value={state.datiSimulazioniSrl.G93}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    /> */}
                {/* <NumberField
                        name="M87"
                        label="Quota dividendo"
                        value={state.compDivSimulazioniSrl.M87}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    /> */}
                <Grid container>
                    <NumberField
                        name="K95"
                        label="Dividendi Imp.Sost."
                        value={state.compDivSimulazioniSrl.K95}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                    <NumberField
                        name="M95"
                        label="Imp.Sost."
                        value={state.compDivSimulazioniSrl.M95}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                    />
                </Grid>
                <SectionTitle text="Addizionali Irpef"></SectionTitle>
                <NumberField
                    name="K99"
                    label="Regionale"
                    value={state.compDivSimulazioniSrl.K99}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />
                <NumberField
                    name="M99"
                    label="Comunale"
                    value={state.compDivSimulazioniSrl.M99}
                    className={gClasses.textFieldReadOnly}
                    readOnly={true}
                    special={true}
                />

            </Paper>
        </React.Fragment>
    )
}